import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-grid p-m-0 kn-flex"
}
const _hoisted_2 = {
  id: "CONTAINER ELEMENT LIST",
  class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column kn-flex"
}
const _hoisted_3 = { class: "p-d-flex p-flex-column kn-flex" }
const _hoisted_4 = { class: "kn-relative kn-flex" }
const _hoisted_5 = { class: "kn-height-full kn-width-full kn-absolute" }
const _hoisted_6 = {
  key: 1,
  class: "p-d-flex p-flex-column kn-flex"
}
const _hoisted_7 = { class: "kn-relative kn-flex" }
const _hoisted_8 = { class: "kn-height-full kn-width-full kn-absolute" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "metaweb-tab-container p-d-flex p-flex-column kn-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_MetawebBusinessPropertyListTab = _resolveComponent("MetawebBusinessPropertyListTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MetawebAttributesTab = _resolveComponent("MetawebAttributesTab")
  const _component_CalculatedField = _resolveComponent("CalculatedField")
  const _component_InboundRelationships = _resolveComponent("InboundRelationships")
  const _component_OutboundRelationships = _resolveComponent("OutboundRelationships")
  const _component_MetawebFilterTab = _resolveComponent("MetawebFilterTab")
  const _component_MetawebJoinRelationships = _resolveComponent("MetawebJoinRelationships")
  const _component_MetawebPhysicalTableTab = _resolveComponent("MetawebPhysicalTableTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Menu = _resolveComponent("Menu")
  const _component_BusinessClassDialog = _resolveComponent("BusinessClassDialog")
  const _component_BusinessViewDialog = _resolveComponent("BusinessViewDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.meta)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ProgressBar, {
                  key: 0,
                  mode: "indeterminate",
                  class: "kn-progress-bar",
                  "data-test": "progress-bar"
                }))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
                start: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.businessClass')), 1)
                ]),
                end: _withCtx(() => [
                  _createVNode(_component_KnFabButton, {
                    icon: "fas fa-plus",
                    onClick: _ctx.showMenu
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_DataTable, {
                    class: "p-datatable-sm metaweb-table kn-table metaweb-right-border",
                    loading: _ctx.loading,
                    scrollable: true,
                    scrollHeight: "100%",
                    value: _ctx.meta.businessModels,
                    onRowClick: _ctx.selectBusinessModel,
                    onRowReorder: _ctx.onRowReorder,
                    "data-test": "bm-table"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        rowReorder: true,
                        reorderableColumn: false
                      }),
                      _createVNode(_component_Column, {
                        style: _ctx.mainDescriptor.style.columnMain
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("span", null, _toDisplayString(slotProps.data.name), 1),
                          _createVNode(_component_Chip, {
                            label: slotProps.data.columns.length + ' ' + _ctx.$t('metaweb.businessModel.tabView.attributes'),
                            class: "p-ml-2",
                            style: _ctx.mainDescriptor.style.chip
                          }, null, 8, ["label", "style"])
                        ]),
                        _: 1
                      }, 8, ["style"]),
                      _createVNode(_component_Column, {
                        style: _ctx.mainDescriptor.style.columnTrash
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Button, {
                            icon: "pi pi-trash",
                            class: "p-button-link",
                            onClick: ($event: any) => (_ctx.deleteFromList(slotProps.data))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  }, 8, ["loading", "value", "onRowClick", "onRowReorder"])
                ])
              ])
            ]),
            (_ctx.meta.businessViews.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
                    start: _withCtx(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.businessView')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_DataTable, {
                        class: "p-datatable-sm metaweb-table kn-table metaweb-right-border",
                        loading: _ctx.loading,
                        scrollable: true,
                        scrollHeight: "100%",
                        value: _ctx.meta.businessViews,
                        onRowClick: _ctx.selectBusinessModel,
                        onRowReorder: _ctx.onRowReorder
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            rowReorder: true,
                            reorderableColumn: false
                          }),
                          _createVNode(_component_Column, {
                            style: _ctx.mainDescriptor.style.columnMain
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("span", null, _toDisplayString(slotProps.data.name), 1),
                              _createVNode(_component_Chip, {
                                label: slotProps.data.columns.length + ' ' + _ctx.$t('metaweb.businessModel.tabView.attributes'),
                                class: "p-ml-2",
                                style: _ctx.mainDescriptor.style.chip
                              }, null, 8, ["label", "style"])
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_Column, {
                            style: _ctx.mainDescriptor.style.columnTrash
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_Button, {
                                icon: "pi pi-trash",
                                class: "p-button-link",
                                onClick: ($event: any) => (_ctx.deleteFromList(slotProps.data))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["loading", "value", "onRowClick", "onRowReorder"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", {
            id: "CONTAINER ELEMENT DETAILS",
            class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 p-d-flex p-flex-column",
            style: _ctx.mainDescriptor.style.flex3
          }, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withCtx(() => [
                (_ctx.selectedBusinessModel)
                  ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.selectedBusinessModel.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (Object.keys(_ctx.selectedBusinessModel).length !== 0)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode(_component_TabView, {
                    class: "metaweb-tabview p-d-flex p-flex-column kn-flex",
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TabPanel, null, {
                        header: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.propertyTitle')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode("div", {
                            style: _ctx.mainDescriptor.style.absoluteScroll
                          }, [
                            _createVNode(_component_MetawebBusinessPropertyListTab, {
                              selectedBusinessModel: _ctx.selectedBusinessModel,
                              roles: _ctx.roles,
                              propMeta: _ctx.meta,
                              onMetaUpdated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('metaUpdated')))
                            }, null, 8, ["selectedBusinessModel", "roles", "propMeta"])
                          ], 4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, null, {
                        header: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.attributes')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode("div", {
                            style: _ctx.mainDescriptor.style.absoluteScroll
                          }, [
                            _createVNode(_component_MetawebAttributesTab, {
                              selectedBusinessModel: _ctx.selectedBusinessModel,
                              propMeta: _ctx.meta,
                              observer: _ctx.observer,
                              roles: _ctx.roles,
                              onMetaUpdated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('metaUpdated')))
                            }, null, 8, ["selectedBusinessModel", "propMeta", "observer", "roles"])
                          ], 4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, null, {
                        header: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.calcField')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode("div", {
                            style: _ctx.mainDescriptor.style.absoluteScroll
                          }, [
                            _createVNode(_component_CalculatedField, {
                              selectedBusinessModel: _ctx.selectedBusinessModel,
                              propMeta: _ctx.meta,
                              propCustomFunctions: _ctx.customFunctions,
                              onMetaUpdated: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('metaUpdated'))),
                              observer: _ctx.observer
                            }, null, 8, ["selectedBusinessModel", "propMeta", "propCustomFunctions", "observer"])
                          ], 4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, null, {
                        header: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.inbound')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode("div", {
                            style: _ctx.mainDescriptor.style.absoluteScroll
                          }, [
                            _createVNode(_component_InboundRelationships, {
                              selectedBusinessModel: _ctx.selectedBusinessModel,
                              propMeta: _ctx.meta,
                              observer: _ctx.observer
                            }, null, 8, ["selectedBusinessModel", "propMeta", "observer"])
                          ], 4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, null, {
                        header: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.outbound')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode("div", {
                            style: _ctx.mainDescriptor.style.absoluteScroll
                          }, [
                            _createVNode(_component_OutboundRelationships, {
                              selectedBusinessModel: _ctx.selectedBusinessModel,
                              propMeta: _ctx.meta,
                              observer: _ctx.observer
                            }, null, 8, ["selectedBusinessModel", "propMeta", "observer"])
                          ], 4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, null, {
                        header: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.filter')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode("div", {
                            style: _ctx.mainDescriptor.style.absoluteScroll
                          }, [
                            _createVNode(_component_MetawebFilterTab, {
                              selectedBusinessModel: _ctx.selectedBusinessModel,
                              propMeta: _ctx.meta,
                              onMetaUpdated: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('metaUpdated')))
                            }, null, 8, ["selectedBusinessModel", "propMeta"])
                          ], 4)
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedBusinessModel.joinRelationships != undefined)
                        ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                            header: _withCtx(() => [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.tabView.joinRelationships')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode("div", {
                                style: _ctx.mainDescriptor.style.absoluteScroll
                              }, [
                                _createVNode(_component_MetawebJoinRelationships, {
                                  selectedBusinessModel: _ctx.selectedBusinessModel,
                                  propMeta: _ctx.meta,
                                  observer: _ctx.observer
                                }, null, 8, ["selectedBusinessModel", "propMeta", "observer"])
                              ], 4)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.selectedBusinessModel.joinRelationships != undefined)
                        ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                            header: _withCtx(() => [
                              _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.physicalTable')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode("div", {
                                style: _ctx.mainDescriptor.style.absoluteScroll
                              }, [
                                _createVNode(_component_MetawebPhysicalTableTab, {
                                  selectedBusinessModel: _ctx.selectedBusinessModel,
                                  propMeta: _ctx.meta,
                                  observer: _ctx.observer
                                }, null, 8, ["selectedBusinessModel", "propMeta", "observer"])
                              ], 4)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 4)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"]),
    (_ctx.showBusinessClassDialog)
      ? (_openBlock(), _createBlock(_component_BusinessClassDialog, {
          key: 1,
          meta: _ctx.meta,
          observer: _ctx.observer,
          physicalModels: _ctx.meta.physicalModels,
          showBusinessClassDialog: _ctx.showBusinessClassDialog,
          onCloseDialog: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showBusinessClassDialog = false))
        }, null, 8, ["meta", "observer", "physicalModels", "showBusinessClassDialog"]))
      : _createCommentVNode("", true),
    (_ctx.showBusinessViewDialog)
      ? (_openBlock(), _createBlock(_component_BusinessViewDialog, {
          key: 2,
          meta: _ctx.meta,
          observer: _ctx.observer,
          showBusinessViewDialog: _ctx.showBusinessViewDialog,
          onCloseDialog: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showBusinessViewDialog = false))
        }, null, 8, ["meta", "observer", "showBusinessViewDialog"]))
      : _createCommentVNode("", true)
  ], 64))
}